import { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
// require('dotenv').config();
const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div className={`lg:block ${isSidebarOpen ? "block" : "hidden"} fixed lg:static z-40`}>
        <AdminSidebar closeSidebar={() => setIsSidebarOpen(false)} />
      </div>

      {/* Main content area */}
      <div className="flex-1 flex flex-col">
        {/* Topbar with hamburger for mobile */}
        <div className="lg:hidden flex items-center justify-between p-4 shadow bg-white">
          <button onClick={() => setIsSidebarOpen(true)}>
            <Menu size={24} className="text-pink-700" />
          </button>
          <h1 className="text-lg font-semibold text-pink-700 font-[Poppins]">
            Admin Panel
          </h1>
        </div>

        {/* Main outlet */}
        <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
